// import { observer } from 'mobx-react';
import * as React from 'react';
// import url from '@/src/scripts/utils/url';
// import common from '@/src/scripts/utils/common';
interface Props {
    re?: boolean;
    setUpdate?: Function;
    update?: boolean;
    sendData?: any[];
    setSendData?: Function;
    dan?: number;
    status?: string;
    goalDetailId?: number;
    claId?: string;
    ordNo?: number;
    type?: string;
    inputType?: string;
    title?: string;
    value?: string;
    maxLength?: number;
    placeholder?: string;
    style?: React.CSSProperties;
    align?: 'left' | 'right' | 'center';
    disabled?: boolean;
    useDel?: boolean;
    selected?: boolean;
    required?: boolean;
    elPh?: React.ReactNode;
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    name?: string;
    shouldClearInput?: boolean;
}

export const TextBox = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, Props>(
    (
        {
            re = false,
            setUpdate,
            dan,
            update,
            goalDetailId,
            sendData,
            status,
            claId,
            ordNo,
            setSendData,
            type = 'text', // Default to 'text' if no type provided
            inputType,
            title,
            value = '',
            placeholder,
            style,
            align,
            maxLength,
            disabled = false,
            useDel = false,
            selected = false,
            required,
            elPh,
            onChange,
            onKeyDown,
            name,
            shouldClearInput = false, // Default to false
        },
        ref
    ) => {
        const [val, setVal] = React.useState<string>(value);
        const handleInputChange: React.ChangeEventHandler<
            HTMLInputElement | HTMLTextAreaElement
        > = (event) => {
            setVal(event.target.value);
            if (onChange) onChange(event);
        };

        const handleInputKeyDown: React.KeyboardEventHandler<
            HTMLInputElement | HTMLTextAreaElement
        > = (event) => {
            if (onKeyDown) onKeyDown(event);
        };

        handleInputKeyDown;

        const handleDelBtnClick = () => {
            if (sendData && setSendData) {
                const gg: any = {
                    goalNm: '',
                    goalDetailId: goalDetailId,
                };
                // if (status === 'uncommon') {
                //   gg.stSetAt = 'Y';
                // }
                //교사가 공통 목표 설정을 할때
                if (status === 'common') {
                    gg.claId = claId;
                    gg.crculId = dan;
                    gg.ordNo = ordNo;
                    gg.tchSetAt = 'N';
                    gg.userType = 'T';
                } else {
                    gg.stSetAt = 'Y';
                    gg.userType = 'S';
                }
                const existingGoalIndex = sendData.findIndex(
                    (item: any) => item.goalDetailId === goalDetailId
                );
                if (existingGoalIndex !== -1) {
                    setSendData((prevData: any) => {
                        const updatedData = [...prevData];
                        updatedData[existingGoalIndex] = gg;
                        return updatedData;
                    });
                } else {
                    setSendData((prevData: any) => [...prevData, gg]);
                }
            }
            setVal('');
        };

        React.useEffect(() => {
            if (shouldClearInput) {
                setVal('');
            }
        }, [shouldClearInput]);

        React.useEffect(() => {
            setVal(value);
        }, [value]);
        React.useEffect(() => {
            if (re) {
                if (value === null) {
                    setVal('');
                } else {
                    setVal(value);
                }
            }
        }, [dan]);
        const returnAlignClass = (alignment?: string) => {
            switch (alignment) {
                case 'left':
                    return 'align-left';
                case 'right':
                    return 'align-right';
                case 'center':
                    return 'align-center';
                default:
                    return '';
            }
        };

        const returnType = (string?: string) => {
            let className = 'text-box';
            if (useDel) className += ' use-del';
            if (selected) className += ' isSelected';
            switch (string) {
                case 'calendar': {
                    className += ' type-calendar';
                    break;
                }
                case 'txt-small': {
                    className += ' type-txt-small';
                    break;
                }
                case 'type2': {
                    if (type === 'textarea') {
                        className += ' area-type2';
                    } else {
                        className += ' input-type2';
                    }
                    break;
                }
                case 'type3': {
                    if (type === 'textarea') {
                        className += ' area-type3';
                    } else {
                        className += ' input-type3';
                    }
                    break;
                }
                case 'type4': {
                    if (type === 'textarea') {
                        className += ' area-type4';
                    } else {
                        className += ' input-type4';
                    }
                    break;
                }
                default:
                    break;
            }
            return className;
        };

        return (
            <div className={returnType(inputType)} style={style}>
                {type === 'textarea' ? (
                    <>
                        <textarea
                            placeholder={placeholder}
                            title={title}
                            maxLength={maxLength}
                            className={returnAlignClass(align)}
                            onChange={handleInputChange}
                            onKeyDown={handleInputKeyDown}
                            name={name}
                            disabled={disabled}
                            ref={ref as React.Ref<HTMLTextAreaElement>}
                            required={required ? true : false}
                            value={value}
                        >
                            {/* {value} */}
                        </textarea>
                        {!value && elPh}
                    </>
                ) : (
                    <>
                        <input
                            type={type}
                            placeholder={placeholder}
                            title={selected ? val + ' 달성완료' : val}
                            value={val}
                            maxLength={maxLength}
                            className={returnAlignClass(align)}
                            onChange={handleInputChange}
                            onKeyDown={handleInputKeyDown}
                            name={name}
                            disabled={disabled}
                            ref={ref as React.Ref<HTMLInputElement>}
                            required={required ? true : false}
                        />
                        {useDel && !disabled && (
                            <button type="button" className="value-del" onClick={handleDelBtnClick}>
                                <span className="sr-only">
                                    {ordNo
                                        ? ordNo === 1
                                            ? '첫번째 입력 값 삭제'
                                            : ordNo === 2
                                              ? '두번째 입력 값 삭제'
                                              : '세번째 입력 값 삭제'
                                        : '입력 값 삭제'}
                                </span>
                            </button>
                        )}
                    </>
                )}
            </div>
        );
    }
);
